/* eslint-disable @typescript-eslint/naming-convention */
import { DbMaalerType } from "../../model/db-maaler-type";
import { MaalerType } from "../../model/maaler-type.model";

export class TestData {
    public static get dbMaalerType1(): DbMaalerType {
        return {
            EMAALTYPE: 1,
            FABRIKAT: "FABRIKAT 1",
            EMAALTYPETEKST: "EMAALTYPETEKST 1",
            PASSIV: true,
            TAELLEVAERKER: []
        };
    }

    public static get dbMaalerType2(): DbMaalerType {
        return {
            EMAALTYPE: 2,
            FABRIKAT: "FABRIKAT 2",
            EMAALTYPETEKST: "EMAALTYPETEKST 2",
            PASSIV: false,
            TAELLEVAERKER: [
                {
                    BESKRIV: "BESKRIV 1",
                    ENHED: 1,
                    ENHED_TEXT: "ENHED_TEXT 1",
                    FAKTOR: "FAKTOR 1",
                    FORMAT: "FORMAT 1",
                    INDEXNAVN: "ENHED_TYPE 1",
                    DECIMALER: -1
                },
                {
                    BESKRIV: "BESKRIV 2",
                    ENHED: 2,
                    ENHED_TEXT: "ENHED_TEXT 2",
                    FAKTOR: "FAKTOR 2",
                    FORMAT: "FORMAT 2",
                    INDEXNAVN: "ENHED_TYPE 2",
                    DECIMALER: -1
                }
            ]
        };
    }

    public static get maalerType1(): MaalerType {
        return {
            fabrikat: "FABRIKAT 1",
            id: 1,
            passiv: true,
            taellevaerker: [],
            tekst: "EMAALTYPETEKST 1"
        };
    }

    public static get maalerType2(): MaalerType {
        return {
            fabrikat: "FABRIKAT 2",
            id: 2,
            passiv: false,
            taellevaerker: [
                {
                    beskrivelse: "BESKRIV 1",
                    enhed: "ENHED_TEXT 1",
                    enhedType: "ENHED_TYPE 1",
                    decimaler: -1
                },
                {
                    beskrivelse: "BESKRIV 2",
                    enhed: "ENHED_TEXT 2",
                    enhedType: "ENHED_TYPE 2",
                    decimaler: -1
                }
            ],
            tekst: "EMAALTYPETEKST 2"
        };
    }

    public static get maalerType3(): MaalerType {
        return {
            fabrikat: "FABRIKAT 3",
            id: 3,
            passiv: false,
            taellevaerker: [
                {
                    beskrivelse: "BESKRIV 1",
                    enhed: "ENHED_TEXT 1",
                    enhedType: "ENHED_TYPE 1",
                    decimaler: -1
                },
                {
                    beskrivelse: "BESKRIV 3",
                    enhed: "ENHED_TEXT 3",
                    enhedType: "ENHED_TYPE 3",
                    decimaler: -1
                },
                {
                    beskrivelse: "BESKRIV 4",
                    enhed: "ENHED_TEXT 4",
                    enhedType: "ENHED_TYPE 4",
                    decimaler: -1
                }
            ],
            tekst: "EMAALTYPETEKST 3"
        };
    }

    public static get alleMaalerTyper(): MaalerType[] {
        return [this.maalerType1, this.maalerType2, this.maalerType3];
    }
}
